module.exports = __webpack_public_path__ + "fonts/Tangerine-400-latin22.6460b53.woff2";